var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "formList",
          rowId: _vm.rowId,
          columns: _vm.columns,
          "toolbar-config": _vm.toolbarConfig,
          editable: true,
          "edit-rules": _vm.editRules,
          treeConfig: _vm.treeConfig,
          ajaxConfig: _vm.ajaxConfig,
          cellDbClick: _vm.cellDbClick,
        },
        on: { "toolbar-addData": _vm.addRow },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.toolbarConfig.templatelSlots,
              fn: function () {
                return [
                  _c(
                    "vxe-button",
                    { on: { click: _vm.addRow } },
                    [
                      _c("a-icon", { attrs: { type: "diff" } }),
                      _vm._v(" 新增 "),
                    ],
                    1
                  ),
                  _c(
                    "vxe-button",
                    { on: { click: _vm.refresh } },
                    [
                      _c("a-icon", { attrs: { type: "redo" } }),
                      _vm._v(" 刷新 "),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "operate",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "vxe-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { size: "mini", status: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.updateRow(row)
                        },
                      },
                    },
                    [_vm._v("编辑")]
                  ),
                  _c(
                    "btn-confirm",
                    {
                      attrs: { title: "确定要删除吗?" },
                      on: {
                        confirm: function ($event) {
                          return _vm.delRow(row)
                        },
                      },
                    },
                    [
                      _c("vxe-button", { attrs: { size: "mini" } }, [
                        _vm._v("删除"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "a-modal",
        {
          attrs: {
            title: "新增节点",
            centered: "",
            closable: false,
            footer: null,
            maskClosable: false,
            visible: _vm.editModalVisible,
            width: 800,
          },
        },
        [
          _vm.editModalVisible
            ? _c("menuManageDetail", {
                ref: "detailForm",
                attrs: { rowId: _vm.editRowId },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeEdit()
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }